import { Coupon } from '@/store/prices/types';

// Kept free of React and react-intl imports so server-side purchase setup can read it.
const isFirstMonthCoupon = (coupon: Coupon | undefined | null): coupon is Coupon =>
	Boolean(
		coupon?.valid &&
		coupon.duration === 'once' &&
		(typeof coupon.percent_off === 'number' || typeof coupon.amount_off === 'number'),
	);

export default isFirstMonthCoupon;
